import * as _ from 'lodash'
import * as React from 'react'

interface IFontAwesomeIconProps extends React.HTMLAttributes<HTMLElement> {
  icon: string
  fixedWidth?: boolean
  muted?: boolean
  color?: string
  spin?: boolean
  regular?: boolean
  size?: 'lg' | 'sm' | 'md' | 'xs'
  verticalAlign?: 'top' | 'middle' | 'bottom' | 'initial' | 'unset' | 'text-bottom'
}

export class FontAwesomeIcon extends React.Component<IFontAwesomeIconProps, {}> {
  getElementClasses() {
    const { fixedWidth, muted, color, spin, icon, regular = false, size = 'lg' } = this.props
    const classes = [(regular ? 'far' : 'fas'), 'fa-fw', `fa-${icon}`]

    const addClassifTrue = (bool: boolean | undefined, className: string) => {
      if (bool) {
        classes.push(className)
      }
    }

    if (typeof this.props.className === 'string') {
      classes.push(this.props.className)
    }

    addClassifTrue(size !== 'md', `fa-${size}`)
    addClassifTrue(fixedWidth, 'fa-fw')
    addClassifTrue(muted, 'icon-muted')
    addClassifTrue(spin, 'fa-spin')

    if (!muted) {
      addClassifTrue(!!color, `icon-${color}`)
    }

    return classes.join(' ')
  }

  render() {
    const props = _.clone(this.props) as IFontAwesomeIconProps
    const { verticalAlign = 'initial' } = props
    delete props.className
    delete props.icon
    delete props.fixedWidth
    delete props.muted
    delete props.color
    delete props.regular
    delete props.verticalAlign
    delete props.spin

    const style = { verticalAlign }

    return (
      <i className={this.getElementClasses()} style={style} {...props}></i>
    )
  }
}
